/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createShiftCover} from '../api'

export const useMutationCreateShiftCover = createReactQueryMutationHook('createShiftCover', createShiftCover)
